/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_P2Inputs */

const en_wc_tut_ui_p2 = /** @type {(inputs: Wc_Tut_Ui_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't find a button? Use command search. Every one of WordCraft's 422 commands can be found by name.`)
};

/**
* | output |
* | --- |
* | "Can't find a button? Use command search. Every one of WordCraft's 422 commands can be found by name." |
*
* @param {Wc_Tut_Ui_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_p2 = /** @type {((inputs?: Wc_Tut_Ui_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_p2(inputs)
});
export { wc_tut_ui_p2 as "wc.tut.ui.p2" }